import React from 'react';
import classes from './Spinner.module.scss';

const Spinner: React.FC = () => <div className={classes.loader} />;

export default Spinner;
